import { Stack, Box, Flex, Text } from "@chakra-ui/react"
import { Slider } from "../../../ui/slider"
import useStore from "../../../../store"
import { useState } from "react"

export default function UtilizationFilter() {
  const dealerTableFilterParams = useStore((state) => state.dealerTableFilterParams)
  const setDealerTableFilterParams = useStore((state) => state.setDealerTableFilterParams)
  const minUtilization = dealerTableFilterParams['utilization[min]'] || 0
  const maxUtilization = dealerTableFilterParams['utilization[max]'] || 100
  const [sliderValues, setSliderValues] = useState([minUtilization, maxUtilization])

  const handleUtilizationChange = (e) => {
    setSliderValues(e.value)
  }

  const handleUtilizationChangeEnd = (e) => {
    const [min, max] = e.value
    const utilObj = {
      "utilization[min]": min.toString(),
      "utilization[max]": max.toString(),
    }

    setDealerTableFilterParams({ ...dealerTableFilterParams, ...utilObj })
  }

  return(
    <Box p={4}>
      <Stack spacing={3} mb={4}>
      <Flex alignItems="center" justifyContent="space-between">
          <Text marginRight={4}>{sliderValues[0]}%</Text>
          <Slider
            data-testid='slider'
            aria-label={['min', 'max']}
            value={sliderValues}
            width="full"
            min={0}
            max={100}
            step={5}
            onValueChange={handleUtilizationChange}
            onValueChangeEnd={handleUtilizationChangeEnd}
          />
          <Text marginLeft={4}>{sliderValues[1]}%</Text>
        </Flex>
      </Stack>
    </Box>

  )
}